import {
	diagJQueryOverrides,
} from '@helpers/diagJQueryOverrides';
import {
	logger,
} from '@config/logger';

export const initJQuery = () => {
	if (window.jQuery && window.$ == undefined) {
		logger.info('Re-attaching jQuery !');
		window.$ = window.jQuery;
	}

	if (localStorage.getItem('diagJQueryOverrides') === 'true') {
		diagJQueryOverrides();
	}
};
